import { useFeatureFlagsContext } from '../components/FeatureFlags/FeatureFlags';

export enum SUBSCRIPTION_STATE {
  ENABLED_36_MONTH,
  ENABLED_48_MONTH,
}

export const useSubscriptionsState = () => {
  const { isFlagEnabled } = useFeatureFlagsContext();
  const is36MonthSubscriptionEnabled = isFlagEnabled('enable-36-month-subscriptions');

  const subscriptionsState = is36MonthSubscriptionEnabled
    ? SUBSCRIPTION_STATE.ENABLED_36_MONTH
    : SUBSCRIPTION_STATE.ENABLED_48_MONTH;

  return {
    subscriptionsState,
  };
};
